import React from 'react';
import { useTranslation } from 'react-i18next';

const IMAGE_TYPES = ['image'];
const VIDEO_TYPES = ['video'];
const DOCUMENT_TYPES = ['document'];

const resolveMediaKind = (contentType, templateType) => {
  const mimeType = String(contentType || '').toLowerCase();
  const type = String(templateType || '').toLowerCase();

  if (mimeType.startsWith('image/') || IMAGE_TYPES.includes(type)) return 'image';
  if (mimeType.startsWith('video/') || VIDEO_TYPES.includes(type)) return 'video';
  if (mimeType === 'application/pdf' || mimeType.startsWith('application/') || DOCUMENT_TYPES.includes(type)) {
    return 'document';
  }

  return 'image';
};

const ReminderMediaPreviewMC = ({ fileUrl, contentType, templateType, className = '' }) => {
  const { t } = useTranslation();

  if (!fileUrl) return null;

  const mediaKind = resolveMediaKind(contentType, templateType);

  if (mediaKind === 'video') {
    return (
      <div className={`tw-rounded-lg tw-overflow-hidden ${className}`}>
        <video
          src={fileUrl}
          className="tw-block tw-w-full tw-max-h-48 !tw-max-w-none"
          controls
        />
      </div>
    );
  }

  if (mediaKind === 'document') {
    return (
      <div className={className}>
        <a
          href={fileUrl}
          target="_blank"
          rel="noreferrer"
          className="tw-text-blue-500 tw-text-sm"
        >
          {t('message_detail.view_document')}
        </a>
      </div>
    );
  }

  return (
    <div className={`tw-rounded-lg tw-h-48 tw-overflow-hidden ${className}`}>
      <img
        src={fileUrl}
        alt={t('message_detail.image_preview')}
        className="tw-block tw-w-full tw-h-full tw-object-cover tw-rounded-lg !tw-max-w-none !tw-max-h-none"
      />
    </div>
  );
};

export default ReminderMediaPreviewMC;
